export const FETCH_LIST_ALL_DELETED_COMPANIES_REQUEST = 'FETCH_LIST_ALL_DELETED_COMPANIES_REQUEST'
export const FETCH_LIST_ALL_DELETED_COMPANIES_SUCCESS = 'FETCH_LIST_ALL_DELETED_COMPANIES_SUCCESS'
export const FETCH_LIST_ALL_DELETED_COMPANIES_FALUIRE = 'FETCH_LIST_ALL_DELETED_COMPANIES_FALUIRE'
export const SEARCH_DELETED_COMPANIES = 'SEARCH_DELETED_COMPANIES'
